import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import ReactModal from "react-modal";
import { IoReload } from "react-icons/io5";
import DescripcionPerfil from "./DescripcionPerfil";
import EditarPerfil from "./EditarPerfil";
import EliminarSubTitulo from "./EliminaSubTitulo";

function InfoPerfilAdmin({ idInstitucion }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const URL = `https://suadesarrollo.azurewebsites.net/api/ObtenerPerfilAutoevaluacion/${idInstitucion}`;

  // 🔄 Función para cargar los datos
  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const { data } = await axios.get(URL);
      setUsers(data || []);
    } catch (err) {
      console.error("Error al obtener los datos:", err);
      setError("No se pudo cargar la información del perfil.");
    } finally {
      setLoading(false);
    }
  };

  // 🚀 Cargar datos al abrir modal (evita llamadas innecesarias)
  useEffect(() => {
    if (modalIsOpen) fetchData();
  }, [modalIsOpen]);

  // 🔍 Filtro optimizado con useMemo
  const filteredUsers = useMemo(() => {
    if (!search.trim()) return users;
    return users.filter((u) =>
      u.subtitulos?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, users]);

  return (
    <div>
      <button
        className="btn btn-primary"
        onClick={() => setModalIsOpen(true)}
        style={{ minWidth: 100 }}
      >
        Perfil
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        ariaHideApp={false}
        style={{
          content: {
            maxWidth: "90%",
            margin: "auto",
            borderRadius: "10px",
            padding: "20px",
          },
        }}
      >
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex justify-content-between align-items-center">
              <h6 className="m-0 font-weight-bold text-primary">
                Información del Perfil
              </h6>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={fetchData}
                title="Recargar datos"
                disabled={loading}
              >
                <IoReload size={18} />
              </button>
            </div>

            <div className="card-body">
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                type="text"
                placeholder="Buscar por subtítulo"
                className="form-control mb-3"
              />

              {loading ? (
                <div className="text-center my-4">
                  <div className="spinner-border text-primary" role="status" />
                  <p className="mt-2">Cargando información...</p>
                </div>
              ) : error ? (
                <div className="alert alert-danger text-center">{error}</div>
              ) : filteredUsers.length === 0 ? (
                <div className="alert alert-warning text-center">
                  No hay registros disponibles.
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered" id="dataTable">
                    <thead className="table-light">
                      <tr>
                        <th>Id</th>
                        <th>Institución</th>
                        <th>Título</th>
                        <th>Subtítulo</th>
                        <th>Descripción</th>
                        <th>Editar</th>
                        <th>Eliminar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUsers.map((item) => (
                        <tr key={item.idregistro}>
                          <td>{item.idregistro}</td>
                          <td>{item.idInstitucion}</td>
                          <td>{item.tituloId}</td>
                          <td>{item.subtitulos}</td>
                          <td>
                            <DescripcionPerfil
                              idRegistro={item.idregistro}
                              institucionId={idInstitucion}
                              subtitulosId={item.subtitulosId}
                            />
                          </td>
                          <td>
                            <EditarPerfil Id={item.idregistro} />
                          </td>
                          <td>
                            <EliminarSubTitulo Id={item.idregistro} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          <div className="text-center mt-3">
            <button
              className="btn btn-secondary"
              onClick={() => setModalIsOpen(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default InfoPerfilAdmin;
